import {AudioFeatures} from './index'
import {shapeSimilarity} from 'curve-matcher'

const asCurves = (a: AudioFeatures) => {
  return [
    {x: a.tempo / 1000, y: a.loudness},
    {x: a.mode, y: a.key},
    {x: a.valence, y: a.speechiness},
    {x: a.danceability, y: a.energy},
    {x: a.instrumentalness, y: a.acousticness}
  ]
}

export const sortSimilar = (a: AudioFeatures, b: AudioFeatures) => {
  return shapeSimilarity(asCurves(a), asCurves(b), {checkRotations: false})
}
